<template>
	<div class="culturalpro">

		<headerview :cur="4"></headerview>
		<div class="content">

			<div class="moddlecon w13">
				<div class="tipcon">
					<tipcon :title="'文化产品'" :name="'文化产品>'+tabname" :imgtype="'2'" width="2.12"></tipcon>
				</div>

				<div class="carcon">
					<div class="l_c">
						<div class="frame">
							<div class="signle" v-for="(item,index) in tablist" :key="index"
							@click="changetab(index)">
							    <img v-show="tabindex != index" class="" src="../../../static/img/mininav@2x.png" alt=""/>
								<img v-show="tabindex == index" class="" src="../../../static/img/mininav_cur@2x.png" alt=""/>
								<span :class="tabindex == index?'text_cur':'text'">{{item}}</span>
							</div>
						</div>

					</div>
					<div class="r_c">
					    <div>
							<div class="videoframe" v-if="tabindex == 0 && !ifvideodetail">
								<div class="signle" v-for="(item,index) in listo" :key="index"
								@click="seevideodetail(item)">
									<!-- <img :src="$imgUrl + item.picture_dictText" alt=""/>  :title="item.title"-->
									<el-image v-if='item.picture_dictText' :src="$imgUrl + item.picture_dictText" fit="contain"></el-image>
									<el-image v-else :src="require('../../../static/index/squareimg.png')" fit="contain"></el-image>
									<div class="titlecon" :title="item.title || ''">{{item.title || ''}}</div>
								</div>
							</div>

							<div class="videodetail" v-if="tabindex == 0 && ifvideodetail">
								<!-- <div class="shareto">
									分享至:
									<img class="imgwc" src="../../../static/img/wechat@2x.png" alt=""/>
									<img class="imgqq" src="../../../static/img/qq@2x.png" alt="" @click="qqshare"/>
								</div> -->

								<div class="title">{{videoinform.title || ''}}</div>
								<div class="timesource">{{videoinform.pubTime || ''}}
									<span style="margin-left: 20px;" v-if='videoinform.source'>来源: {{videoinform.source || ''}}</span>
								</div>
								<div class="line"></div>
								<div class="video">
									<video :src="$imgUrl + videoinform.videoUrl_dictText"  controls="controls"></video>
								</div>
							</div>

							<div class="listcon_public" style="margin-left: 40px;"
							 v-if="tabindex != 0 && !ifdetail">
								<div class="signle wrap" v-for="(item,index) in list" :key="index" @click="seedetail(item)">
									<div class="title overfh" :title="item.title">{{item.title}}</div>
									<div class="time">{{item.createTime.split(' ')[0] || ''}}</div>
								</div>
							</div>

							<div class="detailscon" v-if="tabindex != 0 && ifdetail">
								<textdetails :informdata="informdata"></textdetails>
							</div>
						</div>

						<!-- 分页 -->
						<div class="" v-if="(tabindex != 0 && !ifdetail) || (tabindex == 0 && !ifvideodetail)">
							<div is='footPage' class="zhini-pagination"
							  :currentPage="pageNo"
							  :totalPage="total?total:0"
								 ref="foot"
							  @pageNum="pageNum"  :pagesize='pageSize'></div>
						</div>

					</div>
				</div>

			</div>

		</div>

		<footview></footview>
	</div>

</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import textdetails from "../../../com/textdetails.vue";
import footPage from '../../../components/footpage/footpage.vue'
export default {
  components: {
  	  tipcon,
	  textdetails,
	  footPage,
  },
  data: function() {
		return {
			list:[],
			listo:[],
			tabindex:0,
			productType:1,
		    tablist:["视频","海报","图解","宣讲图文","电子刊","歌曲"],
			tabname:"视频",
			ifvideodetail:false,
			ifdetail:false,
			pageNo:1,
			total:'',
			pageSize:12,

			id:"",
			informdata:{
				title:"标题名称标题名称标题名称",
				source:"来源来着",
				datetime:"2021-01-01 13:12:00",
				contentval:"文本内容文本内容文本内容文本内容文本内容"
			},
			videoinform:{},

		};
  },

  mounted() {
	  	if(this.$route.query.type||this.$route.query.type==0){ 
			  this.tabname=this.tablist[this.$route.query.type]
		}
	  	
	    this.$onScrollT()

		if(this.$route.query) {
			this.tabindex = this.$route.query.type;
			this.productType = parseInt(this.tabindex) + 1

			this.id = this.$route.query.id;
			if(this.id != undefined && this.id != ''){
				if(this.productType == 1){
					this.ifvideodetail = true
				}else{
					this.ifdetail = true
				}
				this.getCulturalDetail(this.id)
			}
		}

		this.getCulturalpro()
  },

  methods: {
		getCulturalpro(){
			this.pageSize = 8
			if(this.productType == 1){
				this.pageSize = 12
			}
			this.$get(`web/culturalproduct/list?pageSize=${this.pageSize}&pageNo=${this.pageNo}&productType=${this.productType}`).then(res=>{
				if(res.success){
					if(this.productType == 1){
						this.listo = res.result.records
					}else{
						this.list = res.result.records
					}
					this.total = res.result.total
				}
			})
		},

		getCulturalDetail(id){
			this.$get(`web/culturalproduct/queryById?id=${id}`).then(res=>{
				if(res.success){
					if(this.productType == 1){
						this.videoinform = res.result
					}else{
						this.informdata.title = res.result.title
						this.informdata.source = res.result.source
						this.informdata.datetime = res.result.pubTime
						this.informdata.contentval = res.result.introduction
					}

				}
			})
		},

	    changetab(index){
			// console.log('changetab',index)
			if(index == 0){
				this.tabname = "视频"
			}else if(index == 1){
				this.tabname = "海报"
			}else if(index == 2){
				this.tabname = "图解"
			}else if(index == 3){
				this.tabname = "宣讲图文"
			}else if(index == 4){
				this.tabname = "电子刊"
			}else if(index == 5){
				this.tabname = "歌曲"
			}
			this.pageNo = 1
			if(this.$refs.foot){ 
				this.$refs.foot.chooseIndex = 1
			}
			
			this.tabindex = index
			this.productType = index + 1
			if(this.tabindex == 0){
				this.ifvideodetail = false
			}else{
				this.ifdetail = false
			}
			this.getCulturalpro()
	    },

		seevideodetail(item){
			this.ifvideodetail = true
			this.getCulturalDetail(item.id)
		},

		seedetail(item){
			this.ifdetail = true
			this.getCulturalDetail(item.id)
		},

		pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getCulturalpro()
		},

		qqshare(){
			window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(document.location.href));
		}

  },


};
</script>

<style scoped="scoped" lang="scss">

.culturalpro{

	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			min-height: 850px;
			.carcon{
				display: flex;
				min-height: 200px;
				.l_c{
					.frame{
						width: 212px;
						height: 300px;
						background: #FFFFFF;
						border: 1px solid #E6E6E6;
						.signle{
							cursor: pointer;
							height: 50px;
							display: flex;
							align-items: center;
							border-top: 1px solid #E6E6E6;
							img{
								margin-left: 10px;
								margin-right: 40px;
								width: 10px;
								height: 12px;
							}
							.text_cur,.text{ 
								font-size: 18px;
								font-weight: 400;
							}
							.text_cur{
								color: #E61F26;
							}
							.text{
								color: #000000;
							}
						}
					}

				}
				.r_c{
					flex: 1;
					.videoframe{
						display: flex;
						flex-wrap: wrap;
						margin-top: 40px;
						margin-left: 80px;
						.signle{
							width: 30%;
							height: 180px;
							cursor: pointer;
							margin-right: 20px;
							margin-bottom: 40px;
							font-size: 18px;
							font-weight: 400;
							color: #000000;
							text-align: center;

							img,.el-image{
								width: 283px;
								height: 162px;
							}
							.titlecon{
								height: 40px;
								line-height: 40px;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						}
					}

					.videodetail{
						.shareto{
							height: 50px;
							display: flex;
							align-items: center;
							justify-content: flex-end;
							.imgwc,.imgqq{
								cursor: pointer;
								margin-left: 20px;
								height: 22px;
							}
							.imgwc{
								width: 26px;
							}
							.imgqq{
								width: 18px;
							}
						}
						.title{
							font-size: 30px;
							font-weight: bold;
							color: #333333;
							text-align: center;
							margin-top: 40px;
							height: 50px;
							line-height: 50px;
						}
						.timesource{
							font-size: 16px;
							color: #666666;
							text-align: center;
							height: 30px;
							line-height: 30px;
						}
						.line{
							margin-left: 40px;
							margin-right: 40px;
							height: 1px;
							background-color: #ededed;
						}
						.video{
							margin-top: 40px;
							display: flex;
							justify-content: center;
							video{
								width: 780px;
								height: 440px;
							}
						}

					}

					.detailscon{
						margin-left: 40px;
					}

				}
			}

		}

	}


}
.listcon_public .signle .title{
	width: calc(100% - 150px);
}
</style>
